export const xs = 320;
export const sm = 480;
export const md = 768;
export const lg = 980;
export const xl = 1200;
